"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStrict = void 0;
var internals_1 = require("./internals");
function parseStrict(parsers, object) {
    // @ts-expect-error
    return object === undefined
        ? // @ts-expect-error
            function (o) { return internals_1._parse(parsers, o); }
        : internals_1._parse(parsers, object);
}
exports.parseStrict = parseStrict;
// endregion
